export function policyNumber (value) {
  if (value == null || typeof value === 'boolean' || (typeof value === 'string' && !value.trim())) return null
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

export function policyProgress (value, target) {
  const current = policyNumber(value)
  const goal = policyNumber(target)
  if (current == null || goal == null || goal <= 0) return null
  const percent = Math.max(0, current / goal * 100)
  return Number.isFinite(percent) ? percent : null
}

export function policyDisplayNumber (value) {
  const number = policyNumber(value)
  return number == null ? '—' : String(Math.round(number * 100) / 100)
}
